module.exports = __webpack_public_path__ + "img/survey.fb1b8ecf.svg";